import { useAlternateProductsData } from "~/features/cart/cartV2/hooks/useAlternateProductsData";
import AlternateProductsPanel from "~/features/cart/cartV2/components/AlternateProductsPanel";

export interface AlternateProductsProps {
  onClose: () => void;
  alternateProductsId: string;
  alternativesFor: string;
  onRender?: (element: Element) => void;
  orderEntryNumber?: number;
  tableId?: string;
  rowId?: string;
  onAlternateAddedToCart?: (data: {
    productCode: string;
    designation: string;
    tableId?: string;
    rowId?: string;
    anchorCartEntryIndex?: number;
  }) => void;
}

const AlternateProducts = ({
  onClose,
  alternateProductsId,
  alternativesFor,
  orderEntryNumber,
  tableId,
  rowId,
  onRender,
  onAlternateAddedToCart,
}: AlternateProductsProps) => {
  const { isLoading, alternateProducts } = useAlternateProductsData({ alternateProductsId });

  return (
    <AlternateProductsPanel
      alternateProducts={alternateProducts}
      isLoading={isLoading}
      alternativesFor={alternativesFor}
      alternateProductsId={alternateProductsId}
      orderEntryNumber={orderEntryNumber}
      tableId={tableId}
      rowId={rowId}
      onClose={onClose}
      onRender={onRender}
      onAlternateAddedToCart={onAlternateAddedToCart}
    />
  );
};

export default AlternateProducts;
